import { OBJLoader2 } from "three/examples/jsm/loaders/OBJLoader2";
import { LoadingManager, TextureLoader, Texture, Object3D } from "three";
import { ResourcesOptions } from "./resources";

export type AllRes = {
  mountainModel: Promise<Object3D>;
  mountainTextureTop: Texture;
  mountainTextureBody: Texture;
  mountainMaskTop: Texture;
  mountainMaskBody: Texture;
  cloudTexture: Texture;
};

const loadingMsgs = [
  "山体定位...",
  "正在部署扫描仪...",
  "正在山体扫描...",
  "山体模型扫描成功...",
  "正在进行数据存储分析...",
  "正在重建模型...",
  "调出展示中...",
  "重建成功",
]

const logProcess = (content: string) => {
  const el = document.getElementById('loading-process')
  const msg = document.createElement('p')
  msg.innerHTML = content
  el?.appendChild(msg)
}

export const loadAllResource = (res: ResourcesOptions): AllRes => {
  logProcess(`10%: ${loadingMsgs.shift()}`)
  var manager = new LoadingManager();
  manager.onLoad = function () {
    console.log("Loading complete!");
    logProcess(`100%: ${loadingMsgs.shift()}`)
    setTimeout(() => {
      const el = document.getElementById('loading-process')
      el?.parentElement?.removeChild(el)
    }, 3000);
  };
  manager.onProgress = function (url, itemsLoaded, itemsTotal) {
    logProcess(`${Math.round(itemsLoaded * 100 / itemsTotal).toString()}%: ${loadingMsgs.shift()}`)
    console.log(url);
  };
  manager.onError = function (url) {
    console.log("There was an error loading " + url);
    logProcess(`0%: 山体扫描任务失败。 ${url} 资源加载失败！`)
  };

  const objPromise = new Promise<Object3D>((r, j) => {
    new OBJLoader2(manager).load(res.mountainModel, r);
  });

  return {
    mountainModel: objPromise,
    mountainTextureTop: new TextureLoader(manager).load(res.mountainTextureTop),
    mountainTextureBody: new TextureLoader(manager).load(res.mountainTextureBody),
    mountainMaskTop: new TextureLoader(manager).load(res.mountainMaskTop),
    mountainMaskBody: new TextureLoader(manager).load(res.mountainMaskBody),
    cloudTexture: new TextureLoader(manager).load(res.cloudTexture),
  };
};